class Auth {
    constructor() {
        this.authenticated = !!localStorage.getItem("loci_token");
    }

    /**
     * Store token in LocalStorage and update authentication status.
     * @param {Object} data.
     */
    login(data) {
        const token = data.token;
        if (token) {
            localStorage.setItem("loci_token", token);
            this.authenticated = true;
        } else {
            this.authenticated = false;
        }
    }

    /**
     * Return token from LocalStorage.
     * @returns {string|null} token.
     */
    token() {
        return localStorage.getItem("loci_token");
    }

    /**
     * Remove token from LocalStorage and update authentication status.
     */
    logout() {
        localStorage.removeItem("loci_token");
        this.authenticated = false;
    }

    /**
     * Check if user is authenticated.
     * @returns {boolean} true if authenticated, false otherwise.
     */
    isUserAuthenticated() {
        return this.authenticated;
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new Auth();